import { createContext, useContext, ReactNode } from "react";
import { useResourceList } from "../useResourceList";
import { ResourceListDefaults } from "../@types/resource-list-defaults";
import { ResourceContextType } from "../@types/resource-context-type";
import { Resource } from "../@types/resource.type";

export const ResourceContext = createContext<ResourceContextType<any> | undefined>(undefined);

export const ResourceConsumer = ResourceContext.Consumer;

export function ResourceProvider<T>({
  resource,
  children,
  defaults,
  params,
}: {
  resource: Resource;
  children: ReactNode;
  defaults?: ResourceListDefaults;
  params?: Record<string, any>;
}) {
  const resourceData = useResourceList<T>({
    resource,
    defaults,
    params,
  });

  return <ResourceContext.Provider value={resourceData}>{children}</ResourceContext.Provider>;
}

export function useResource<T>() {
  const context = useContext(ResourceContext);
  if (!context) {
    throw new Error("useResource must be used within a ResourceProvider");
  }
  return context as ResourceContextType<T>;
}
